// Libraries
import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

/**
 * A helper directive to focus buttons. You will only need this if using a custom template.
 */
@Directive({
  selector: '[wpFocus]'
})
export class FocusDirective implements OnChanges {
  /**
   * Focus flag.
   */
  @Input() public wpFocus: boolean;

  constructor(private elm: ElementRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.wpFocus && this.wpFocus === true) {
      this.elm.nativeElement.focus();
    }
  }
}
